/* ARTMIE SI rewriter v2 (loop-safe) — generated 2026-05-12T21:32:59.985Z, patched 2026-05-15 for primary domain */
/* Runs on /sl-si/, /sk-si/ paths, OR when the host is artmie.si (post-DNS-cutover primary domain).
   Translates SK→SL UI strings client-side.
   No URL rewriting needed (SI uses the same handles as SK).
   Loop guard: skip pairs where replacement contains the source string. */
(function () {
  var __path = (window.location.pathname || '');
  var __host = (window.location.hostname || '');
  var siMode = /^\/(sl-si|sk-si)(\/|$)/.test(__path) || /(^|\.)artmie\.si$/i.test(__host);
  if (!siMode && window.ArtmieSI !== true) return;

  document.documentElement.classList.add('si-market');
  document.documentElement.setAttribute('data-si-market', '1');

  /* SI-specific CSS injection (currently empty — Heureka widget now translated via metafield) */

  /* FORCE_SI_MARKET — when customer is on /sl-si/ or /sk-si/, ensure Shopify market context is SI */
  function ensureSiMarket() {
    try {
      if (sessionStorage.getItem('artmie_si_market_set') === '1') return;
      var formData = new FormData();
      formData.append('form_type', 'localization');
      formData.append('_method', 'PUT');
      formData.append('country_code', 'SI');
      formData.append('language_code', /^\/sk-si/.test(__path) ? 'sk' : 'sl');
      formData.append('return_to', window.location.pathname);
      fetch('/localization', { method: 'POST', body: formData, credentials: 'same-origin' })
        .then(function () { sessionStorage.setItem('artmie_si_market_set', '1'); })
        .catch(function () {});
    } catch (e) {}
  }
  ensureSiMarket();

  /* CSS injection — hide app-store links sitewide on SI market (ARTMiE has no app in SI). */
  function injectSiCss() {
    if (document.getElementById('artmie-si-injected-css')) return;
    var s = document.createElement('style');
    s.id = 'artmie-si-injected-css';
    s.textContent = [
      'a[href*="apps.apple.com"]{display:none !important;}',
      'a[href*="itunes.apple.com"]{display:none !important;}',
      'a[href*="play.google.com"]{display:none !important;}',
      'a[href*="app.appsflyer.com"]{display:none !important;}',
      '.artmie-app-link-separator{display:none !important;}'
    ].join('\n');
    (document.head || document.documentElement).appendChild(s);
  }
  injectSiCss();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', injectSiCss);

  /* DOM hider — find any block containing an app-store link or the SK/SI app-promo heading
     and hide its sidebar row entirely (icon + heading + sub-text). */
  function hideAppBlocks() {
    /* (1) Walk up from any app-store link to a plausible row container, hide it */
    var appLinks = document.querySelectorAll('a[href*="apps.apple.com"],a[href*="itunes.apple.com"],a[href*="play.google.com"],a[href*="app.appsflyer.com"]');
    for (var i = 0; i < appLinks.length; i++) {
      var el = appLinks[i];
      /* Climb up to 6 levels looking for a typical row/list-item ancestor */
      for (var j = 0; j < 6 && el && el.parentElement; j++) {
        el = el.parentElement;
        var tag = el.tagName && el.tagName.toLowerCase();
        var cls = (el.className && el.className.baseVal !== undefined) ? el.className.baseVal : (el.className || '');
        cls = String(cls);
        if (tag === 'li' || /(\brow\b|\bitem\b|\bcard\b|\bblock\b|\bpdp\b|\binfo\b|delivery|shipping|app)/i.test(cls)) {
          el.style.display = 'none';
          break;
        }
      }
    }
    /* (2) Hide any element whose visible text mentions the app heading (SK/SI variants) */
    var phrases = ['Stiahni si ARTMiE appku', 'Stiahni si ARTMIE appku', 'Prenesi aplikacijo ARTMiE',
      'S appkou brezplačna dostava', 'S aplikáciou doprava zdarma',
      'S appkou bezplatná doprava', 'doprava ZADARMO Od 49€'];
    for (var k = 0; k < phrases.length; k++) {
      var p = phrases[k];
      var walker = document.createTreeWalker(document.body || document.documentElement, NodeFilter.SHOW_TEXT, null);
      var t;
      while ((t = walker.nextNode())) {
        if (t.nodeValue && t.nodeValue.indexOf(p) !== -1) {
          var node = t.parentElement;
          for (var m = 0; m < 6 && node && node.parentElement; m++) {
            var nc = node.className || '';
            nc = String(nc.baseVal !== undefined ? nc.baseVal : nc);
            var nt = node.tagName && node.tagName.toLowerCase();
            if (nt === 'li' || /(\brow\b|\bitem\b|\bcard\b|\bblock\b|\bpdp\b|\binfo\b|delivery|shipping|app)/i.test(nc)) {
              node.style.display = 'none';
              break;
            }
            node = node.parentElement;
          }
        }
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hideAppBlocks);
  else hideAppBlocks();
  setTimeout(hideAppBlocks, 500);
  setTimeout(hideAppBlocks, 1500);
  setTimeout(hideAppBlocks, 3000);

  /* URL prefix fix — ensure all internal links go to /sl-si/ or /sk-si/ (avoid leaking to bare SK paths) */
  /* PATCH 2026-05-15: On the SI primary domain (artmie.si), the market is at the root path — DO NOT prefix.
     Only prefix when serving from the legacy subfolder (/sl-si/ or /sk-si/ on czartmie.myshopify.com or app.artmie.sk). */
  var SI_ON_PRIMARY_DOMAIN = /(^|\.)artmie\.si$/i.test(__host);
  var SI_TARGET = SI_ON_PRIMARY_DOMAIN ? '' : (/^\/sk-si/.test(__path) ? '/sk-si' : '/sl-si');
  var MARKET_PREFIX_RX = /^\/(sl-si|sk-si|de-de|de-at)(?:\/|$|\?|#)/;
  /* Hosts that represent the SK customer-facing site — convert these to /sl-si/ paths */
  var SK_HOST_RX = /^https?:\/\/(www\.)?(app\.artmie\.sk|artmie\.sk|czartmie\.myshopify\.com)/i;
  /* Paths we should NOT prefix: API, cart, checkout, account auth, asset URLs, etc. */
  var SKIP_PATH_RX = /^\/(cart|checkout|localization|account\/login|account\/register|account\/logout|password|wpm@|tools\/|s\/files\/|recommendations\/|search\/suggest|apps\/|api\/|services\/|admin)(\/|\?|$)/;
  function normaliseHref(h) {
    if (!h) return null;
    if (/^(mailto:|tel:|sms:|javascript:|#)/i.test(h)) return null;
    /* Absolute URL to SK customer-facing host → strip host, treat path as relative */
    if (SK_HOST_RX.test(h)) {
      h = h.replace(SK_HOST_RX, '');
      if (h === '' || h === '/') h = '/';
    } else if (/^https?:/i.test(h)) {
      return null; /* truly external URL, leave alone */
    }
    /* At this point h starts with / or is a relative path */
    if (h.charAt(0) !== '/') return null; /* skip pure-relative anchor links */
    if (MARKET_PREFIX_RX.test(h)) return null; /* already on a market */
    /* Fix the buggy concat '/sl-sipages/...' or '/sl-sicollections/...' some templates emit */
    var fixedConcat = h.match(/^\/sl-si([a-z])/);
    if (fixedConcat) {
      return '/sl-si/' + h.slice(6);
    }
    var fixedConcatSk = h.match(/^\/sk-si([a-z])/);
    if (fixedConcatSk) {
      return '/sk-si/' + h.slice(6);
    }
    if (SKIP_PATH_RX.test(h)) return null;
    if (h === '/') return SI_TARGET + '/';
    /* Strip default-locale prefix /sl/ or /sk/ */
    var stripped = h.replace(/^\/(sl|sk)(\/|$)/, '/');
    /* On primary domain (SI_TARGET=''), strip any incoming /sl-si/ or /sk-si/ prefix instead of adding */
    if (SI_TARGET === '') {
      var noLocaleSubfolder = stripped.replace(/^\/(sl-si|sk-si)(\/|$)/, '/');
      return noLocaleSubfolder;
    }
    return SI_TARGET + stripped;
  }
  /* ARTMIE_MKT_SWITCH_GUARD 2026-05-16 — never rewrite URLs/text inside the cross-domain country switcher. */
  function isInMktSwitch(node) {
    if (!node || !node.closest) return false;
    return !!node.closest('.artmie-mkt-switch, [data-artmie-no-rewrite]');
  }
  function fixHrefPrefix() {
    var anchors = document.querySelectorAll('a[href]');
    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i];
      if (isInMktSwitch(a)) continue; /* cross-domain country switcher — leave alone */
      var h = a.getAttribute('href');
      var newH = normaliseHref(h);
      if (newH && newH !== h) a.setAttribute('href', newH);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixHrefPrefix);
  else fixHrefPrefix();
  setTimeout(fixHrefPrefix, 500);
  setTimeout(fixHrefPrefix, 1500);
  setTimeout(fixHrefPrefix, 3000);

  /* SK → SL text rewrites */
  var TEXT_REWRITES = {
  "Stolové, ateliérové, poľné": "Namizna, ateljejska, terenska",
  "Späť na ": "Nazaj na ",
  "Späť do obchodu": "Nazaj v trgovino",
  "Najnovšie články": "Najnovejši članki",
  "Zobraziť všetky": "Prikaži vse",
  "min čítania": "min branja",
  "Čítať článok": "Preberi članek",
  "Čítať viac": "Preberi več",
  "min. čítania": "min. branja",
  "čítania": "branja",
  "Všetko": "Vse",
  "Hodnotenia zákazníkov": "Ocene strank",
  "hodnoteni": "ocen",
  "hodnotení": "ocen",
  "Recenzie": "Ocene",
  "recenzia": "ocena",
  "recenzií": "ocen",
  "Napísať recenziu": "Napiši oceno",
  "Overená recenzia": "Preverjena ocena",
  "Overena recenzia": "Preverjena ocena",
  "Ďakujeme za tvoju recenziu": "Hvala za vašo oceno",
  "Tvoje hodnotenie": "Vaša ocena",
  "Podeľ sa o svoju skúsenosť": "Delite svojo izkušnjo",
  "Pridať recenziu": "Dodaj oceno",
  "Pridať do košíka": "Dodaj v košarico",
  "Do košíka": "V košarico",
  "DO KOŠÍKA": "V KOŠARICO",
  "Pridané do košíka": "Dodano v košarico",
  "Pridať všetky do košíka": "Dodaj vse v košarico",
  "Vyber variant": "Izberi različico",
  "Vyberte variant": "Izberite različico",
  "Vyberte variantu": "Izberite različico",
  "Vyberte si variantu": "Izberite različico",
  "Vyber variantu": "Izberi različico",
  "Môj zoznam želaní": "Moj seznam želja",
  "Váš zoznam želaní je prázdny.": "Tvoj seznam želja je prazen.",
  "Váš zoznam želaní je prázdny": "Tvoj seznam želja je prazen",
  "Zoznam želaní je prázdny": "Seznam želja je prazen",
  "Prezrieť produkty": "Preglej izdelke",
  "produktov": "izdelkov",
  "produktu": "izdelka",
  "produkty": "izdelki",
  "Košík je prázdny": "Košarica je prazna",
  "Nákupný košík": "Nakupovalna košarica",
  "Košík": "Košarica",
  "v košíku": "v košarici",
  "Zatvoriť": "Zapri",
  "Zavrieť": "Zapri",
  "Otvoriť": "Odpri",
  "Zobraziť": "Prikaži",
  "Zobraziť všetko": "Prikaži vse",
  "Zobraziť viac": "Prikaži več",
  "Zobraziť menej": "Prikaži manj",
  "Skryť": "Skrij",
  "Späť": "Nazaj",
  "Pokračovať": "Nadaljuj",
  "Pokračovať v nákupe": "Nadaljuj z nakupovanjem",
  "Pokračovať na pokladňu": "Nadaljuj na blagajno",
  "Hľadať": "Iskanje",
  "Vyhľadať": "Išči",
  "Vyhľadávanie": "Iskanje",
  "Vymazať": "Počisti",
  "Vymazať všetko": "Počisti vse",
  "Triediť": "Razvrsti",
  "Zoradiť": "Razvrsti",
  "Načítavanie": "Nalaganje",
  "Načítavam": "Nalagam",
  "Načítava sa": "Nalaganje",
  "Načítať viac": "Naloži več",
  "Popis": "Opis",
  "Vyberte": "Izberite",
  "Vyberte si": "Izberite si",
  "Veľkosť": "Velikost",
  "Farba": "Barva",
  "Materiál": "Material",
  "Značka": "Znamka",
  "Skladom": "Na zalogi",
  "Vypredané": "Razprodano",
  "Nedostupné": "Ni na voljo",
  "Posledné kusy": "Zadnji kosi",
  "Bežná cena": "Redna cena",
  "Zľava": "Popust",
  "Zľavnené": "Znižano",
  "Stiahni si aplikáciu": "Prenesi aplikacijo",
  // --- SI product-page sidebar fixes (delivery, app, returns) ---
  "Doručenie do 1–2 pracovných dní": "Pošljemo isti dan",
  "Doručenie do 1-2 pracovných dní": "Pošljemo isti dan",
  "Dostava do 1–2 delovnih dni": "Pošljemo isti dan",
  "Dostava do 1-2 delovnih dni": "Pošljemo isti dan",
  "Doručenie do 1–2 dní": "Pošljemo isti dan",
  "Doručenie do 1-2 dní": "Pošljemo isti dan",
  "S Packeta od 2,10 € · Zdarma nad 49 €": "Z GLS Slovenija od 3,90 € · Brezplačno nad 49 €",
  "S Packeta od 2,10 €": "Z GLS Slovenija od 3,90 €",
  "S Packeta od": "Z GLS Slovenija od",
  "Zdarma nad 49 €": "Brezplačno nad 49 €",
  "S aplikáciou doprava zdarma": "Z aplikacijo brezplačna dostava",
  "Stiahni si ARTMiE appku:": "Prenesi aplikacijo ARTMiE:",
  "Stiahni si ARTMiE appku": "Prenesi aplikacijo ARTMiE",
  "Stiahni si ARTMIE appku": "Prenesi aplikacijo ARTMIE",
  "100-dňové vrátenie bez udania dôvodu": "100-dnevno vračilo brez navedbe razloga",
  "100-dňové vrátenie": "100-dnevno vračilo",
  "bez udania dôvodu": "brez navedbe razloga",
  "Jednoducho a bez starostí": "Enostavno in brez skrbi",
  "Bez starostí": "Brez skrbi",
  // --- add-to-cart button fallbacks (some themes render just the verb) ---
  "Pridať do košíka": "Dodaj v košarico",
  "PRIDAŤ DO KOŠÍKA": "DODAJ V KOŠARICO",
  "Pridať": "Dodaj",
  "Pridané": "Dodano",
  "PRIDANÉ": "DODANO",
  // --- blog navigation labels ---
  "Všetky blogy": "Vsi blogi",
  "Všetky články": "Vsi članki",
  "Vyberte si tému, ktorá vás zaujíma": "Izberite temo, ki vas zanima",
  "Tipy, návody a inšpirácia pre rôzne maliarske techniky.": "Nasveti, navodila in navdih za različne slikarske tehnike.",
  "Skicovanie, kreslenie a ilustrátorské tipy.": "Skiciranje, risanje in ilustratorski nasveti.",
  "Pomôžeme vám vybrať tie správne výtvarné potreby.": "Pomagamo vam izbrati prave likovne potrebščine.",
  "Tvorivé nápady a postupy krok za krokom.": "Ustvarjalne ideje in koraki po korakih.",
  "Inšpirácie zo sveta umenia a od umelcov.": "Navdihi iz sveta umetnosti in od umetnikov.",
  "Tvorivé aktivity pre deti každého veku.": "Ustvarjalne dejavnosti za otroke vseh starosti.",
  "Aktuality, novinky a komunitné príspevky.": "Aktualnosti, novosti in skupnostni prispevki.",
  "Príbehy a informácie o značkách v našom sortimente.": "Zgodbe in informacije o znamkah v našem sortimentu.",
  "Všetky blogy ARTMiE": "Vsi blogi ARTMiE",
  // --- review form consent text + upload widget ---
  "Strinjam se s obchodnými podmienkami a zásadami ochrany osobných údajov": "Strinjam se s splošnimi pogoji in pravilnikom o zasebnosti",
  "obchodnými podmienkami a zásadami ochrany osobných údajov": "splošnimi pogoji in pravilnikom o zasebnosti",
  "obchodnými podmienkami": "splošnimi pogoji",
  "obchodné podmienky": "splošni pogoji",
  "zásadami ochrany osobných údajov": "pravilnikom o zasebnosti",
  "zásady ochrany osobných údajov": "pravilnik o zasebnosti",
  "ochrany osobných údajov": "varstva osebnih podatkov",
  "ochrana osobných údajov": "varstvo osebnih podatkov",
  "Max. 3 datoteke, do 5 MB. JPG, PNG alebo MP4.": "Maks. 3 datoteke, do 5 MB. JPG, PNG ali MP4.",
  "JPG, PNG alebo MP4": "JPG, PNG ali MP4",
  "alebo MP4": "ali MP4",
  "do 5 MB": "do 5 MB",
  "Prihlásenie": "Prijava",
  "Prihlásiť sa": "Prijava",
  "Odhlásiť sa": "Odjava",
  "Registrácia": "Registracija",
  "Nová registrácia": "Nova registracija",
  "Registrovať sa": "Registriraj se",
  "Môj účet": "Moj račun",
  "Objednávky": "Naročila",
  "Nemáte účet": "Nimate računa",
  "Zoznam želaní": "Seznam želja",
  "Pokladňa": "Blagajna",
  "Doručenie": "Dostava",
  "Súhrn objednávky": "Povzetek naročila",
  "Medzisúčet": "Vmesni seštevek",
  "Prihlásiť sa na odber": "Naročite se na novice",
  "Odoberať novinky": "Naročite se na novice",
  "Najnovšie zľavy a inšpirácie": "Najnovejši popusti in navdihi",
  "Súhlasím so spracovaním osobných údajov": "Strinjam se z obdelavo osebnih podatkov",
  "Nenechajte si ujsť": "Ne zamudite",
  "NENECHAJTE SI UJSŤ": "NE ZAMUDITE",
  "Pomoc a informácie": "Pomoč in informacije",
  "O nás": "O nas",
  "Kontaktujte nás": "Kontaktirajte nas",
  "Sledujte nás": "Spremljajte nas",
  "SLEDUJTE NÁS": "SPREMLJAJTE NAS",
  "Sme tu pre vás": "Tu smo za vas",
  "Odoslať": "Pošlji",
  "Poslať": "Pošlji",
  "Uložiť": "Shrani",
  "Upraviť": "Uredi",
  "Pridať": "Dodaj",
  "Odstrániť": "Odstrani",
  "Zmazať": "Izbriši",
  "Potvrdiť": "Potrdi",
  "Zrušiť": "Prekliči",
  "Áno": "Da",
  "voliteľné": "neobvezno",
  "povinné": "obvezno",
  "nepovinné": "neobvezno",
  "súbor": "datoteka",
  "súbory": "datoteke",
  "obrázok": "slika",
  "telefón": "telefon",
  "správa": "sporočilo",
  "odpovedať": "odgovori",
  "Tvoje meno": "Vaše ime",
  "Tvoj email": "Vaš e-poštni naslov",
  "Fotka alebo video": "Fotografija ali video",
  "Pri preprave bohužiaľ došlo": "Med prevozom je žal prišlo do",
  "Ohodnoť tento produkt": "Oceni ta izdelek",
  "Stránkovanie": "Strani",
  "stránka": "stran",
  "výsledkov": "rezultatov",
  "výsledok": "rezultat",
  "Hodnotenia zakaznikov": "Ocene strank",
  "Hodnotenia zakazníkov": "Ocene strank",
  "Hodnotenia": "Ocene",
  "Na základe": "Na podlagi",
  "Na zaklade": "Na podlagi",
  "zákazníkov": "strank",
  "zákazník": "stranka",
  "pridať": "dodaj",
  "Pridáva sa": "Dodajanje",
  "pridáva sa": "dodajanje",
  "kúpiť teraz": "kupi zdaj",
  "Kúpiť teraz": "Kupi zdaj",
  "KÚPIŤ TERAZ": "KUPI ZDAJ",
  "Nakup teraz": "Nakupuj zdaj",
  "na sklade": "na zalogi",
  "Na sklade": "Na zalogi",
  "NA SKLADE": "NA ZALOGI",
  "Nie je na sklade": "Ni na zalogi",
  "nie je na sklade": "ni na zalogi",
  "doručenie": "dostava",
  "doručenia": "dostave",
  "pracovných dní": "delovnih dni",
  "pracovný deň": "delovni dan",
  "Zákazník": "Stranka",
  "Zákaznícky servis": "Pomoč strankam",
  "ZÁKAZNÍCKY SERVIS": "POMOČ STRANKAM",
  "Alternatívne Produkty": "Alternativni izdelki",
  "Alternatívne produkty": "Alternativni izdelki",
  "ALTERNATÍVNE PRODUKTY": "ALTERNATIVNI IZDELKI",
  "Alternatívny produkt": "Alternativni izdelek",
  "alternatívne": "alternativni",
  "zákaznícky servis": "pomoč strankam",
  "Farby a médiá": "Barve in mediji",
  "Plátna a papiere": "Platna in papirji",
  "Štetce a pomôcky": "Čopiči in pripomočki",
  "Kreatívne potreby": "Ustvarjalni material",
  "Značky": "Blagovne znamke",
  "Akryl, olej, akvarel": "Akril, olje, akvarel",
  "Na ráme, rolky, bloky": "Na okvirju, role, bloki",
  "Stolové, atelierove, poľné": "Namizna, ateljejska, terenska",
  "Zľavy až -80%": "Popusti do -80%",
  "Zľavy až": "Popusti do",
  "Akrylové, olejové, akvarelové": "Akrilne, oljne, akvarelne",
  "Kreslenie a ilustrácia": "Risba in ilustracija",
  "Sady, guľaté, ploché": "Kompleti, okrogli, ploski",
  "Živica, dekupáž, šperky": "Smola, dekupaž, nakit",
  "O tejto kategórii": "O tej kategoriji",
  "O TEJTO KATEGÓRII": "O TEJ KATEGORIJI",
  "O kategórii": "O kategoriji",
  "Predchádzajúca stránka": "Prejšnja stran",
  "Nasledujúca stránka": "Naslednja stran",
  "Predošlá stránka": "Prejšnja stran",
  "Ďalšia stránka": "Naslednja stran",
  "Predošlá": "Prejšnja",
  "Ďalšia": "Naslednja",
  "Strana": "Stran",
  "celkom": "skupaj",
  "Triediť podľa": "Razvrsti po",
  "Zoradiť podľa": "Razvrsti po",
  "Najnovšie": "Najnovejše",
  "Najstaršie": "Najstarejše",
  "Najpredávanejšie": "Najbolj prodajano",
  "Cena: nízka → vysoká": "Cena: nizka → visoka",
  "Cena: vysoká → nízka": "Cena: visoka → nizka",
  "Cena vzostupne": "Cena naraščajoče",
  "Cena zostupne": "Cena padajoče",
  "Názov A-Z": "Ime A-Z",
  "Názov Z-A": "Ime Z-A",
  "Manuálne": "Ročno",
  "Náhodne": "Naključno",
  "Najlepšie hodnotené": "Najbolje ocenjeno",
  "Abecedne, A-Z": "Abecedno, A-Z",
  "Abecedne, Z-A": "Abecedno, Z-A",
  "Cena, od najvyššej": "Cena, od najvišje",
  "Cena, od najnižšej": "Cena, od najnižje",
  "Dátum, od najnovšieho": "Datum, od najnovejšega",
  "Dátum, od najstaršieho": "Datum, od najstarejšega",
  "Vyčistiť filtre": "Počisti filtre",
  "Vymazať filtre": "Izbriši filtre",
  "Aktívne filtre": "Aktivni filtri",
  "Vybrané": "Izbrano",
  "Aplikovať": "Uporabi",
  "Zobraziť výsledky": "Prikaži rezultate",
  "Zobraziť produkty": "Prikaži izdelke",
  "Skryť filtre": "Skrij filtre",
  "Zobraziť filtre": "Prikaži filtre",
  "Cenové rozpätie": "Cenovni razpon",
  "Cenová kategória": "Cenovna kategorija",
  "Dostupnosť": "Razpoložljivost",
  "Vypredáva sa": "Razprodano",
  "Skladom u dodávateľa": "Na zalogi pri dobavitelju",
  "Žiadne výsledky": "Ni rezultatov",
  "Žiadne produkty": "Ni izdelkov",
  "Nič sa nenašlo": "Nič ni bilo najdenega",
  "Skús inú kombináciu filtrov": "Poskusi drugo kombinacijo filtrov",
  "Načítavajú sa produkty": "Nalaganje izdelkov",
  "Načítavam produkty": "Nalagam izdelke",
  "Žiaden výsledok": "Nobenega rezultata",
  "Variant": "Različica",
  "Varianty": "Različice",
  "položiek": "elementov",
  "produktov": "izdelkov",
  "produkty": "izdelki",
  "produkt": "izdelek",
  "Rýchle zobrazenie": "Hiter ogled",
  "Rýchly náhľad": "Hiter predogled",
  "Pridať do želaní": "Dodaj na seznam želja",
  "Odstrániť zo želaní": "Odstrani s seznama želja",
  "Pridané do želaní": "Dodano na seznam želja",
  "V košíku": "V košarici",
  "Aktualizovať": "Posodobi",
  "Z košíka": "Iz košarice",
  "Späť k produktom": "Nazaj k izdelkom",
  "Súvisiace produkty": "Sorodni izdelki",
  "Mohlo by vás zaujímať": "Morda vas bo zanimalo",
  "Najnovšie produkty": "Najnovejši izdelki",
  "Odporúčané produkty": "Priporočeni izdelki",
  "Naposledy zobrazené": "Nazadnje ogledano",
  "Naposledy si pozeral": "Nazadnje ste si ogledali",
  "Hmotnosť": "Teža",
  "Rozmery": "Dimenzije",
  "Krajina pôvodu": "Država porekla",
  "Záruka": "Garancija",
  "Kód produktu": "Koda izdelka",
  "Označenie": "Oznaka",
  "Kategória": "Kategorija",
  "Kategórie": "Kategorije",
  "Pridať na zoznam želaní": "Dodaj na seznam želja",
  "Pridať na wishlist": "Dodaj na seznam želja",
  "Domovská stránka": "Domača stran",
  "Hlavná stránka": "Glavna stran",
  "Všetky kategórie": "Vse kategorije",
  "Prejsť k pokladni": "Na blagajno",
  "Prejsť do košíka": "Pojdi v košarico",
  "Suma celkom": "Skupni znesek",
  "Súčet": "Vsota",
  "Bez DPH": "Brez DDV",
  "S DPH": "Z DDV",
  "Vrátane DPH": "Vključno z DDV",
  "Pridajte produkty": "Dodajte izdelke",
  "Vyprázdniť košík": "Izprazni košarico",
  "Aktualizovať košík": "Posodobi košarico",
  "Prihláste sa k odberu": "Naročite se na novice",
  "Odoberajte naše novinky": "Naročite se na naše novice",
  "Zadajte váš e-mail": "Vnesite svoj e-poštni naslov",
  "Vaša e-mailová adresa": "Vaš e-poštni naslov",
  "Vaše meno": "Vaše ime",
  "Súhlasím so spracovaním": "Strinjam se z obdelavo",
  "Prečítať si viac": "Preberi več",
  "Viac informácií": "Več informacij",
  "Vyhľadávanie produktov": "Iskanje izdelkov",
  "Zadajte hľadaný výraz": "Vnesite iskani izraz",
  "Hľadať produkty": "Išči izdelke",
  "Hľadať na webe": "Išči po spletnem mestu",
  "Hľadať produkt": "Išči izdelek",
  "Načítať ďalšie": "Naloži več",
  "Načítať viac produktov": "Naloži več izdelkov",
  "Filtre a triedenie": "Filtri in razvrščanje",
  "Triedenie": "Razvrščanje",
  "Všetky značky": "Vse blagovne znamke",
  "Všetky produkty": "Vsi izdelki",
  "Zobraziť všetky produkty": "Prikaži vse izdelke",
  "Menu": "Meni",
  "Otvoriť menu": "Odpri meni",
  "Zavrieť menu": "Zapri meni",
  "Prihlásiť": "Prijava",
  "Zaregistrovať": "Registracija",
  "Vytvoriť konto": "Ustvari račun",
  "Vytvoriť účet": "Ustvari račun",
  "Adresy": "Naslovi",
  "Moje adresy": "Moji naslovi",
  "Moje objednávky": "Moja naročila",
  "Moje údaje": "Moji podatki",
  "Žiadne objednávky": "Ni naročil",
  "Stav objednávky": "Stanje naročila",
  "Číslo objednávky": "Številka naročila",
  "Spôsob dopravy": "Način dostave",
  "Spôsob doručenia": "Način dostave",
  "Spôsob platby": "Način plačila",
  "Doručovacia adresa": "Naslov za dostavo",
  "Fakturačná adresa": "Naslov za izstavitev računa",
  "Adresa doručenia": "Naslov za dostavo",
  "Hodnotenie produktu": "Ocena izdelka",
  "Žiadne hodnotenia": "Ni ocen",
  "Žiadne recenzie": "Ni recenzij",
  "Buďte prvý": "Bodite prvi",
  "Napíšte prvú recenziu": "Napišite prvo recenzijo",
  "Prijať všetky": "Sprejmi vse",
  "Odmietnuť": "Zavrni",
  "Nastavenia": "Nastavitve",
  "Spravovať": "Upravljaj",
  "Súhlasím": "Strinjam se",
  "Tento web používa": "Ta spletna stran uporablja",
  "Používame súbory cookies": "Uporabljamo piškotke",
  "Toto je informácia o cookies": "To so informacije o piškotkih",
  "Bezpečné platby": "Varna plačila",
  "Rýchle doručenie": "Hitra dostava",
  "Vrátenie tovaru": "Vračilo blaga",
  "14 dní na vrátenie": "14 dni za vračilo",
  "Záruka spokojnosti": "Garancija zadovoljstva",
  "Kvalitné výrobky": "Kakovostni izdelki",
  "Motív": "Motiv",
  "Štýl": "Stil",
  "Izba": "Prostor",
  "Vlastnosti": "Lastnosti",
  "Technika": "Tehnika",
  "Techniky": "Tehnike",
  "Použitie": "Uporaba",
  "Objem": "Prostornina",
  "Objem/Váha": "Prostornina/Teža",
  "Váha": "Teža",
  "Druh": "Vrsta",
  "Typ": "Tip",
  "Forma": "Oblika",
  "Tvar": "Oblika",
  "Tvrdosť": "Trdota",
  "Šírka": "Širina",
  "Výška": "Višina",
  "Dĺžka": "Dolžina",
  "Hrúbka": "Debelina",
  "Priemer": "Premer",
  "Počet kusov": "Število kosov",
  "Balenie": "Pakiranje",
  "Zostava": "Sestav",
  "Súprava": "Komplet",
  "Pre koho": "Za koga",
  "Vhodné pre": "Primerno za",
  "Vek": "Starost",
  "Pohlavie": "Spol",
  "Sezóna": "Sezona",
  "Príležitosť": "Priložnost",
  "Štýl výroby": "Slog izdelave",
  "Ručná práca": "Ročno delo",
  "Zobrazenie": "Prikaz",
  "Mriežka": "Mreža",
  "Zoznam": "Seznam",
  "Otvoriť filter": "Odpri filter",
  "Zatvoriť filter": "Zapri filter",
  "Vybrať": "Izberi",
  "Vyber si": "Izberi",
  "Stojany": "Stojala",
  "Stolové stojany": "Namizna stojala",
  "Ateliérové stojany": "Ateljejska stojala",
  "Poľné stojany do exteriéru": "Terenska stojala za zunanjo uporabo",
  "Poľné stojany": "Terenska stojala",
  "Maliarske stojany - všetky typy": "Slikarska stojala - vsi tipi",
  "Maliarske stojany": "Slikarska stojala",
  "Umelecká lahôdka sa nenašla.": "Umetniške potrebščine niso bile najdene.",
  "Umelecká lahôdka sa nenašla": "Umetniške potrebščine niso bile najdene",
  "Najskôr ju teraz nemáme skladom. Pozrite si ďalšie obľúbené výtvarné potreby.": "Trenutno jih nimamo na zalogi. Poglejte druge priljubljene umetniške potrebščine.",
  "Najskôr ju teraz nemáme skladom.": "Trenutno jih nimamo na zalogi.",
  "Pozrite si ďalšie obľúbené výtvarné potreby.": "Poglejte druge priljubljene umetniške potrebščine.",
  "Prezerať e-shop": "Brskaj po trgovini",
  "PREZERAŤ E-SHOP": "BRSKAJ PO TRGOVINI",
  "Discover something new": "Odkrijte nekaj novega",
  "STIAHNITE SI NAŠU APLIKÁCIU": "PRENESITE NAŠO APLIKACIJO",
  "Stiahnite si našu aplikáciu": "Prenesite našo aplikacijo",
  "Doprava a platba": "Dostava in plačilo",
  "Výmena a vrátenie tovaru": "Zamenjava in vračilo blaga",
  "Často kladené otázky": "Pogosta vprašanja",
  "Obchodné podmienky": "Splošni pogoji poslovanja",
  "Ochrana osobných údajov": "Politika zasebnosti",
  "Spolupráca a veľkoodber": "Sodelovanje in veleprodaja",
  "Pridaj sa do tímu ARTMIE": "Pridruži se ekipi ARTMIE",
  "Po - Pi": "Pon - Pet",
  "Po-Pi": "Pon-Pet",
  "Slovensko": "Slovaška",
  "Hodnotenie obchodu na Heureka.sk": "Ocene trgovine na Heureka.sk",
  "Hodnotenie obchodu": "Ocena trgovine",
  "Stranka": "Stranka",
  "Zlatý certifikát Heureka": "Zlati certifikat Heureka",
  "Zlatý certifikát": "Zlati certifikat",
  "Overené strankami - 98 %": "Preverjeno s strani strank - 98 %",
  "Overené strankami": "Preverjeno s strani strank",
  "Overené zákazníkmi": "Preverjeno s strani strank",
  "Shoproku 2019 - Víťaz": "Shoproku 2019 - Zmagovalec",
  "SHOPROKU 2024 - Víťaz": "SHOPROKU 2024 - Zmagovalec",
  "Shoproku": "Shoproku",
  "Víťaz": "Zmagovalec",
  "VÍŤAZ": "ZMAGOVALEC",
  "Ručné práca a tvorenie": "Ročno delo in ustvarjanje",
  "Ručná práca a tvorenie": "Ročno delo in ustvarjanje",
  "Organizátor medzinárodnej súťaže": "Organizator mednarodnega tekmovanja",
  "Európsky sociálny fond": "Evropski socialni sklad",
  "Zamestnanosť a sociálna inklúzia": "Zaposlovanje in socialna vključenost",
  "Spôsoby platby": "Načini plačila",
  "všetky typy": "vsi tipi",
  "všetky": "vsi",
  "všetkých": "vseh",
  "výtvarné potreby": "umetniške potrebščine",
  "umelecké potreby": "umetniške potrebščine",
  "výtvarné": "umetniške",
  "umelecké": "umetniške",
  "kreatívne": "ustvarjalne",
  "lahôdka": "dobrota",
  "Všetky": "Vse",
  "VŠETKY": "VSE",
  "VŠETKO": "VSE",
  "Váš e-mail": "Vaš e-mail",
  "Váš email": "Vaš e-mail",
  "Vaše e-maily": "Vaši e-poštni naslovi",
  "Tvoj e-mail": "Vaš e-mail",
  "umeleckých potrieb": "umetniških potrebščin",
  "V našom e-shope": "V naši spletni trgovini",
  "V našom obchode": "V naši trgovini",
  "Pri objednávke nad": "Pri naročilu nad",
  "posielame zadarmo": "pošljemo brezplačno",
  "pošta zadarmo": "pošta brezplačno",
  "väčšina": "večina",
  "väčšina produktov": "večina izdelkov",
  "je skladom": "je na zalogi",
  "sú skladom": "so na zalogi",
  "odchádza do dvoch": "odide v dveh",
  "odchádza do": "odide v",
  "pracovných dňoch": "delovnih dneh",
  "rokov": "let",
  "Sme tu od roku": "Tu smo od leta",
  "za tých vyše": "v teh več kot",
  "za tých": "v teh",
  "vyše 15 rokov": "več kot 15 let",
  "sa naučili jedno": "smo se naučili eno",
  "na materiáli záleží": "na materialu je odvisno",
  "Preto pracujeme výhradne so značkami": "Zato delamo izključno z znamkami",
  "o ktorých vieme": "o katerih vemo",
  "že neskhamú": "da ne razočarajo",
  "že nesklamú": "da ne razočarajo",
  "a je ich vyše": "in jih je več kot",
  "štyridsať": "štirideset",
  "Maliarske plátna": "Slikarska platna",
  "Maliarske plátna — základ, na ktorom všetko stojí": "Slikarska platna — temelj, na katerem vse stoji",
  "základ, na ktorom všetko stojí": "temelj, na katerem vse stoji",
  "Štruktúrovacie pasty a efektové médiá ARTMIE": "Strukturne paste in efektni mediji ARTMIE",
  "Štruktúrovacie pasty": "Strukturne paste",
  "efektové médiá": "efektni mediji",
  "Naša vlastná značka": "Naša lastna znamka",
  "priniesla na slovenský trh": "je prinesla na slovaški trg",
  "dostupné a kvalitné": "dostopne in kakovostne",
  "štruktúrovacie pasty": "strukturne paste",
  "trojrozmerné textúry": "tridimenzionalne teksture",
  "reliéfy a efekty": "reliefi in efekti",
  "o akých si pred pár rokmi": "o kakršnih ste pred nekaj leti",
  "Butter pasta": "Butter pasta",
  "Reliéfna pasta": "Reliefna pasta",
  "3D pasta": "3D pasta",
  "Maliarske plátno": "Slikarsko platno",
  "plátno na ráme": "platno na okvirju",
  "plátna ECO": "platna ECO",
  "plátna PROFI": "platna PROFI",
  "plátno na rolke": "platno na roli",
  "okrúhle plátno": "okroglo platno",
  "plátno na lepenke": "platno na lepenki",
  "dvojito šepsované": "dvakrat impregnirano",
  "pripravené na okamžité maľovanie": "pripravljeno za takojšnje slikanje",
  "akrylom": "z akrilom",
  "olejom": "z oljem",
  "zmiešanými technikami": "mešanimi tehnikami",
  "Ak hľadáš": "Če iščete",
  "najlepší pomer ceny a kvality": "najboljše razmerje med ceno in kakovostjo",
  "skús": "poskusite",
  "Pre výstavy a profesionálnu tvorbu": "Za razstave in profesionalno ustvarjanje",
  "profesionálnu": "profesionalno",
  "hrubším rámom a hustejším tkaním": "debelejšim okvirjem in gostejšim tkanjem",
  "A ak si radšej": "In če si raje",
  "pripravíš vlastný formát": "pripravite svoj format",
  "nastrihneš si presne toľko, koľko potrebuješ": "odrežete točno toliko, kolikor potrebujete",
  "maliarskych plátien": "slikarskih platen",
  "akrylových farieb": "akrilnih barv",
  "výrobcov": "proizvajalcev",
  "cez": "preko",
  "až po": "do",
  "ráme": "okvirju",
  "rolky": "role",
  "bloky": "bloki",
  "metráž": "po meri",
  "dvoch": "dveh",
  "troch": "treh",
  "jeden": "en",
  "Dnes Doprava ZADARMO Od 49€": "Danes brezplačna dostava od 49 €",
  "Doprava ZADARMO Od 49€": "Brezplačna dostava od 49 €",
  "Doprava ZADARMO Od 49 €": "Brezplačna dostava od 49 €",
  "Doprava ZADARMO od 49€": "Brezplačna dostava od 49 €",
  "Doprava ZADARMO od 49 €": "Brezplačna dostava od 49 €",
  "doprava zadarmo od 49€": "brezplačna dostava od 49 €",
  "Doprava ZADARMO": "Brezplačna dostava",
  "DOPRAVA ZADARMO": "BREZPLAČNA DOSTAVA",
  "doprava zadarmo": "brezplačna dostava",
  "Dnes": "Danes",
  "DNES": "DANES",
  "Od 49€": "od 49 €",
  "od 49€": "od 49 €",
  "od 49 €": "od 49 €",
  "Nakupuj teraz": "Nakupujte zdaj",
  "NAKUPUJ TERAZ": "NAKUPUJTE ZDAJ",
  "Nakupuj teraz →": "Nakupujte zdaj →",
  "Zadajte text...": "Vnesite besedilo...",
  "Zadajte text": "Vnesite besedilo",
  "Zadajte text vyhľadávania": "Vnesite iskalni izraz",
  "Zadajte hľadaný text": "Vnesite iskalni izraz",
  "Po - Ne / 9:00 - 20:00": "Pon - Ned / 9:00 - 20:00",
  "Po - Ne": "Pon - Ned",
  "Zákaznicky servis": "Pomoč strankam",
  "ZÁKAZNICKY SERVIS": "POMOČ STRANKAM",
  "Spoločnosť": "Podjetje",
  "SPOLOČNOSŤ": "PODJETJE",
  "E-SHOP ARTMIE": "E-TRGOVINA ARTMIE",
  "E-shop ARTMIE": "E-trgovina ARTMIE",
  "POMOC A INFORMÁCIE": "POMOČ IN INFORMACIJE",
  "Sociálne médiá": "Družbeni mediji",
  "SOCIÁLNE MÉDIÁ": "DRUŽBENI MEDIJI",
  "už od 49€": "že od 49 €",
  "už od 49 €": "že od 49 €",
  "už od": "že od",
  "PRIHLÁSENIE": "PRIJAVA",
  "NOVÁ REGISTRÁCIA": "NOVA REGISTRACIJA",
  "info@artmie.sk": "info@artmie.si",
  "artmie.sk": "artmie.com",
  "INFO@ARTMIE.SK": "INFO@ARTMIE.SI",
  "ARTMiE.SK": "ARTMIE",
  "ARTMIE.SK": "ARTMIE",
  "Inšpirácia, techniky a tipy pre každého umelca": "Navdih, tehnike in nasveti za vsakega umetnika",
  "Inšpirácia": "Navdih",
  "INŠPIRÁCIA": "NAVDIH",
  "inšpirácia": "navdih",
  "inšpirácie": "navdihe",
  "inšpiráciu": "navdih",
  "techniky a tipy": "tehnike in nasveti",
  "TECHNIKY A TIPY": "TEHNIKE IN NASVETI",
  "pre každého umelca": "za vsakega umetnika",
  "pre každého": "za vsakega",
  "každého umelca": "vsakega umetnika",
  "umelca": "umetnika",
  "umelcov": "umetnikov",
  "umelec": "umetnik",
  "umelci": "umetniki",
  "umelecké potreby pre Vaše umenie": "umetniške potrebščine za vašo umetnost",
  "pre Vaše umenie": "za vašo umetnost",
  "pre vaše umenie": "za vašo umetnost",
  "vaše umenie": "vaša umetnost",
  "Výpredaj": "Razprodaja",
  "VÝPREDAJ": "RAZPRODAJA",
  "výpredaj": "razprodaja",
  "ARTMIE Slovenija": "ARTMIE Slovenija",
  "naozaj": "res",
  "najmä": "predvsem",
  "avšak": "vendar",
  "predovšetkým": "predvsem",
  "najprv": "najprej",
  "nakoniec": "nazadnje",
  "potom": "nato",
  "predtým": "pred tem",
  "samozrejme": "seveda",
  "najlepší": "najboljši",
  "najlepšia": "najboljša",
  "najlepšie": "najboljše",
  "najvyšší": "najvišji",
  "najnižší": "najnižji",
  "info@artmie.com": "info@artmie.si",
  "reklamacie@artmie.sk": "reklamacie@artmie.si",
  "reklamacie@artmie.com": "reklamacie@artmie.si",
  "INFO@ARTMIE.COM": "INFO@ARTMIE.SI"
};

  /* Loop guard: filter out any pair whose replacement contains the source string */
  var TEXT_KEYS = Object.keys(TEXT_REWRITES)
    .filter(function (k) { return TEXT_REWRITES[k].indexOf(k) === -1; })
    .sort(function (a, b) { return b.length - a.length; });

  function rewriteTextNode(node) {
    if (!node || node.nodeType !== 3) return;
    var t = node.nodeValue;
    if (!t || !/\S/.test(t)) return;
    var changed = false;
    for (var i = 0; i < TEXT_KEYS.length; i++) {
      var k = TEXT_KEYS[i];
      if (t.indexOf(k) === -1) continue;
      var rep = TEXT_REWRITES[k];
      /* Escape regex chars in key */
      var rx = new RegExp(k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
      var newT = t.replace(rx, rep);
      if (newT !== t) { t = newT; changed = true; }
    }
    if (changed) node.nodeValue = t;
  }

  function walkAndRewrite(root) {
    if (!root) return;
    /* ARTMIE_MKT_SWITCH_GUARD 2026-05-16 — skip the cross-domain country switcher so native names ("Slovensko", "Polska", etc.) stay intact. */
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function(node){
        var p = node.parentNode;
        if (p && p.closest && p.closest('.artmie-mkt-switch, [data-artmie-no-rewrite]')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    }, false);
    var n; while ((n = w.nextNode())) rewriteTextNode(n);
    /* Also: rewrite common attribute values (placeholder, alt, title, aria-label, value on buttons) */
    var ATTR_SELECTORS = ['[placeholder]', '[alt]', '[title]', '[aria-label]', 'input[type="submit"]', 'input[type="button"]', 'button'];
    var atrs = root.querySelectorAll ? root.querySelectorAll(ATTR_SELECTORS.join(',')) : [];
    for (var i = 0; i < atrs.length; i++) {
      var el = atrs[i];
      if (el.closest && el.closest('.artmie-mkt-switch, [data-artmie-no-rewrite]')) continue; /* ARTMIE_MKT_SWITCH_GUARD */
      ['placeholder', 'alt', 'title', 'aria-label', 'value'].forEach(function (a) {
        var v = el.getAttribute(a);
        if (!v) return;
        var nv = v;
        for (var j = 0; j < TEXT_KEYS.length; j++) {
          var k = TEXT_KEYS[j];
          if (nv.indexOf(k) === -1) continue;
          var rx = new RegExp(k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
          nv = nv.replace(rx, TEXT_REWRITES[k]);
        }
        if (nv !== v) el.setAttribute(a, nv);
      });
    }
  }

  /* Initial pass — PERF 2026-05-19: collapsed from 3 passes to 1 because most theme content
   * is now server-translated (SI translations completed across collections, articles, reviews,
   * pages). Single pass at DOMContentLoaded catches remaining client-rendered strings. The
   * MutationObserver below picks up any later AJAX swaps. */
  function initialPass() {
    walkAndRewrite(document.body);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialPass);
  else initialPass();

  /* MutationObserver — PERF 2026-05-19: narrowed scope. Dropped characterData+attributes;
   * they fired on every Horizon web-component update (hundreds of times per page life) and
   * almost never produced a meaningful re-translation. childList+subtree catches the only
   * real case: AJAX-injected product cards / facet results. Debounce raised to 300ms. */
  /* PERF FIX 2026-05-21: process only the nodes each mutation actually added, instead
     of re-walking the whole document.body. The old debouncedPass ran
     walkAndRewrite(document.body) — O(all text nodes x ~400 keys) — on every AJAX /
     web-component update, which froze big collections and many-variant product pages. */
  var pending = null;
  var rwQueue = [];
  function flushQueue() {
    pending = null;
    var nodes = rwQueue; rwQueue = [];
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.nodeType === 1) {
        if (node.isConnected) walkAndRewrite(node);
      } else if (node.nodeType === 3) {
        rewriteTextNode(node);
      }
    }
    fixHrefPrefix();
  }
  function debouncedPass(mutations) {
    for (var mi = 0; mi < mutations.length; mi++) {
      var added = mutations[mi].addedNodes;
      for (var ai = 0; ai < added.length; ai++) {
        var n = added[ai];
        if (n.nodeType === 1 || n.nodeType === 3) rwQueue.push(n);
      }
    }
    if (rwQueue.length && !pending) pending = setTimeout(flushQueue, 300);
  }
  function startObserver() {
    if (!document.body) { setTimeout(startObserver, 100); return; }
    try {
      var mo = new MutationObserver(debouncedPass);
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }
  startObserver();

  /* Intercept clicks on un-prefixed internal links and rewrite-on-click as a last-resort safety net */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    if (isInMktSwitch(a)) return; /* ARTMIE_MKT_SWITCH_GUARD: don't touch country-switcher links */
    var h = a.getAttribute('href');
    var newH = normaliseHref(h);
    if (newH && newH !== h) a.setAttribute('href', newH);
  }, true);
})();
